<template>
  <div class="metrics" style="margin-top: 2%;">
    <el-row justify="center" type="flex">
      <el-col  :span="20" >
        <el-table v-loading="pieLoading"
          :data="tableDataPage.filter(data => !search || data.instance.toLowerCase().includes(search.toLowerCase()))">
          <el-table-column prop="instance" label="Instance Name" align="left"></el-table-column>
          <el-table-column prop="status" label="Status" align="left"></el-table-column>
          <el-table-column prop="pvCount" label="Pv Count" align="left"></el-table-column>
          <el-table-column prop="eventRate" label="Event Rate"  align="left"></el-table-column>
          <el-table-column prop="dataRateGBPerDay" label="Data Rate(GB/Day)"  align="left"></el-table-column>
          <el-table-column prop="capacityUtilized" label="Capacity consumed"  align="left"></el-table-column>
          <el-table-column label="Operate" align="center">
            <template slot="header" slot-scope="scope">
              <el-input  v-model="search" size="large" placeholder="keyword search"/>
            </template>
            <template slot-scope="scope">
              <el-button  title="Detail" type="primary" icon="el-icon-view" circle  @click="handleDetail(scope.$index,scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination 
          background
          layout="total,prev,pager,next"
          :total="gridData.length"
          :page-count="Math.ceil(gridData.length/pageSize)"
          :current-page.sync="currentPage"
          @current-change ="currentPageChange"
          :page-size = "pageSize">
        </el-pagination>
      </el-col>
    </el-row>
    <storageDetail v-if="isLookDetail" 
    @close = "close" 
    :detailData="detailData"
    ></storageDetail>
  </div>
</template>

<script>
import storageDetail from  './storageDetail'
    export default {
      name: "metrics",
      components:{storageDetail},
      data(){
          return {
            iconLoading:true,
            disabled:false,
            pieLoading:false,

            pageNumber:0,
            pageSize:8,
            currentPage:1,

            gridData: [],
            isLookDetail:false,
            queryFrom:{
              keywords:''
            },
            detailData:[],
            search:'',
            tableDataPage:[]
          }
      },
      mounted(){
          this.query();
      },
      methods:{
        query:function () {
          this.$axios({ 
              method:'get',
                url:'/hdars/hdars/mgmt/getStorageMetrics'
              }).then((response) => {
            this.gridData = response.data;
            this.tableDataPage = this.gridData.slice((this.currentPage-1)*this.pageSize,this.currentPage*this.pageSize);
          })
        },
        handleDetail(index,row){
          this.$axios({ 
              method:'get',
                url:'/hdars/hdars/mgmt/getStorageMetricsForAppliance?appliance=' + row.instance
              }).then((response) => {
            this.detailData = response.data
          })
          this.isLookDetail = true;
        },
        currentPageChange:function(val){
          this.currentPage = val;
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
        },
        searchForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              alert('search!');
            } else {
              console.log('error search!!');
              return false;
            }
          });
        },
        close:function(){
          this.isLookDetail = false;
        }
      }
    }

</script>

<style>
  .metrics .el-form-item__label{width:110px;}
  .metrics .el-form-item__content{margin-left:110px}
  .metrics .queryFromClass .el-form-item{display: inline-block;}
  .metrics .el-select{width:100%;}
</style>



// WEBPACK FOOTER //
// src/page/activePublic/Metrics/storage.vue